import InstagramAnalyticsPublicCampaign from './InstagramAnalyticsPublicCampaign.vue'
export default InstagramAnalyticsPublicCampaign
